import { CoreLink } from '@uncinc/react-drupal-core';
import React from 'react';
import config from 'react-global-configuration';

import './style.scss';

const NodeArticleSmall = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const language = config.get('DEFAULT_LANGUAGE');
  const link = entity.getIn(['paths', language], entity.get('paths').first());
  const created = entity.getIn(['created', 0, 'value'], entity.getIn(['changed', 0, 'value'], null));

  const date = new Date(created);
  const dateString = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;

  return (
    <div className="NodeArticleSmall">
      <div className="NodeArticleSmall__date">{dateString}</div>
      <h3 className="NodeArticleSmall__title asH5"><CoreLink to={link}>{title}</CoreLink></h3>
    </div>
  );
};

export default NodeArticleSmall;
